import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import Loginandsignup from '../page/Loginandsignup';
import Contact from '../page/Contact';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ onContactClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const { isAuthenticated, user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const profileImage =
    user?.profilePicture ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'User'
    )}&background=f49778&color=fff&size=128`;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleContactClick = () => {
    setShowContact(true);
  };

  const handleAboutClick = (e) => {
    e.preventDefault();
    setActiveSection('about');
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-content">
          {/* Logo/Brand */}
          <div className="logo-container">
            <a href="/" className="logo-link">
              <img 
                src="/Brown and Orange Event Management Logo.svg" 
                alt="Event Logo" 
                className="logo-img"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-desktop">
            <Link to="/" className={`nav-link ${location.pathname === '/' && !activeSection ? 'active' : ''}`} onClick={() => { setActiveSection(''); window.scrollTo(0, 0); }}>
              Home
            </Link>
            <Link to="/events" className={`nav-link ${location.pathname === '/events' ? 'active' : ''}`} onClick={() => { setActiveSection(''); window.scrollTo(0, 0); }}>
              Events
            </Link>
            <a href="#about" onClick={handleAboutClick} className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}>
              About
            </a>
            <button onClick={handleContactClick} className="nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              Contact
            </button>
            {isAuthenticated ? (
              <div className="profile-dropdown-wrapper">
                <Link to="/dashboard/my-profile" className="profile-icon-container">
                  <img 
                    src={profileImage}
                    alt="Profile" 
                    className="profile-picture"
                  />
                </Link>
                <div className="profile-dropdown-menu">
                  <Link to="/dashboard" className="profile-dropdown-item">
                    Dashboard
                  </Link>
                  <button type="button" className="profile-dropdown-item profile-logout-btn" onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              </div>
            ) : (
              <button onClick={() => setShowLogin(true)} className="login-btn">
                Login
              </button>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            <svg
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-nav ${isMenuOpen ? 'open' : 'closed'}`}>
        <div className="mobile-nav-content">
          <Link
            to="/"
            className={`mobile-nav-link ${location.pathname === '/' && !activeSection ? 'active' : ''}`}
            onClick={() => { setIsMenuOpen(false); setActiveSection(''); window.scrollTo(0, 0); }}
          >
            Home
          </Link>
          <Link
            to="/events"
            className={`mobile-nav-link ${location.pathname === '/events' ? 'active' : ''}`}
            onClick={() => { setIsMenuOpen(false); setActiveSection(''); window.scrollTo(0, 0); }}
          >
            Events
          </Link>
          <a
            href="#about"
            className={`mobile-nav-link ${activeSection === 'about' ? 'active' : ''}`}
            onClick={(e) => { handleAboutClick(e); setIsMenuOpen(false); }}
          >
            About
          </a>
          <button
            className="mobile-nav-link"
            onClick={() => { setIsMenuOpen(false); handleContactClick(); }}
          >
            Contact
          </button>
          {isAuthenticated ? (
            <Link
              to="/dashboard"
              className="mobile-nav-link mobile-profile-link"
              onClick={() => setIsMenuOpen(false)}
            >
              <img src={profileImage} alt="Profile" className="mobile-profile-picture" />
              Profile
            </Link>
          ) : (
            <button
              className="mobile-nav-link"
              onClick={() => { setIsMenuOpen(false); setShowLogin(true); }}
            >
              Login
            </button>
          )}
        </div>
      </div>

      {/* Login Modal */}
      {showLogin && <Loginandsignup onClose={() => setShowLogin(false)} />}
      
      {/* Contact Modal */}
      {showContact && <Contact onClose={() => setShowContact(false)} />}
    </nav>
  );
};

export default Navbar;
